/**
 * When this header is set to "true", global 401 handling (toast + clearAuthData)
 * is skipped for that request. Useful for silent auth flows that should fail quietly.
 *
 * Note: This project’s Angular version doesn’t support HttpContext yet, so we use a header.
 */
export const SKIP_UNAUTHORIZED_HANDLING_HEADER = 'x-skip-unauthorized-handling';

